import Footer from '@/components/Layouts/Footer'
import Header from '@/components/Layouts/Header'
import React from 'react'
import Head from 'next/head'

const RefoundPolicyPage = () => {
    return (
        <>
            <Head>
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0"
                />
                <meta httpEquiv="X-UA-Compatible" content="ie=edge" />
                <title>Cookie Policy - Smart Card Generator</title>
                <meta property="og:type" content="website" />
                <meta
                    property="og:url"
                    content="https://smartcardgenerator.net/cookie-policy"
                />
                <meta
                    property="description"
                    content="Welcome to Smart Card Generator. This Cookie Policy explains how we use cookies and similar technologies on our website and platform. By using our services, you consent to the use of cookies as described in this policy."
                />
                <meta
                    property="og:description"
                    content="Welcome to Smart Card Generator. This Cookie Policy explains how we use cookies and similar technologies on our website and platform. By using our services, you consent to the use of cookies as described in this policy."
                />
                <meta property="og:type" content="Description" />
                <meta
                    property="og:title"
                    content="Cookie Policy - Smart Card Generator"
                />
                <meta
                    property="og:image"
                    content="/img/meta_image/cookie.jpg"
                />
                <meta property="image" content="/img/meta_image/cookie.jpg" />
                <meta property="og:site_name" content="Smart Card Generator" />
            </Head>
            <Header />

            <div className="faq-question-wrapper ">
                <div className="faq-img">
                    <img src="/img/home/refund.svg" alt="" />
                </div>
                <div className="container">
                    <div className="row d-flex align-items-center justify-content-center">
                        <div className="col-md-10">
                            <div className=" faq-content-wrapper">
                                <h1 className="text-center mb-5">
                                    Cancellation Policy
                                </h1>

                                <div className="faq-content-item">
                                    <h2>Cancellation for basic version:</h2>
                                    <p>
                                        Smart Card Generator presents a smart
                                        visiting card, a digital version of a
                                        traditional business card that contains
                                        interactive features and digital
                                        capabilities. The cancellation for this
                                        version will be processed after three
                                        days. The basic version will include
                                        your name, job title, company name,
                                        phone number, email address, and website
                                        to your QR code. When the QR code is
                                        scanned, it directs people to your
                                        digital profile with your general
                                        information.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2>Cancellation for pro version:</h2>
                                    <p>
                                        Make it easy for people to share your
                                        information with others with the "Share"
                                        option or let them keep your information
                                        in their phone contacts. Taking the
                                        Smart Card Generator "pro" level
                                        involves integrating more advanced
                                        features and customization options. The
                                        cancellation will be processed after
                                        five working days for the pro version.
                                        Use the card for seamless activity,
                                        enable offline NFC capabilities,
                                        allowing users to exchange contact
                                        information with nearby devices even
                                        without an internet connection.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2>After Cancellation Refund Policy:</h2>
                                    <p className="description-content">
                                        We regret to inform our users that
                                        refunds are generally not applicable for
                                        purchases made through our Smart Card
                                        Generating system. To request a refund,
                                        users must submit a formal request
                                        stating the reason for cancellation and
                                        providing any necessary evidence of the
                                        company's mistake. This request should
                                        be sent via email to
                                        <span>
                                            {' '}
                                            <a
                                                href="mailto:info.womenindigital@gmail.com"
                                                className="email-link-item">
                                                info.womenindigital@gmail.com
                                            </a>
                                        </span>{' '}
                                        within the 24-hour cancellation window.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2>No Refunds for NFC Cards:</h2>
                                    <p>
                                        Once the smart card has been activated
                                        and the user has received their NFC card
                                        with QR code, no refunds will be issued
                                        for these components. Users are advised
                                        to securely dispose of these items if
                                        they choose to cancel their smart card
                                        subscription.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2>Non-Transferable:</h2>
                                    <p>
                                        Smart cards are non-transferable and
                                        cannot be resold or reused once issued
                                        to a user. Any attempt to transfer,
                                        resell, or reuse these components may
                                        result in immediate cancellation of the
                                        user's subscription without refund.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2>Company's Right to Cancel:</h2>
                                    <p>
                                        The company reserves the right to cancel
                                        a user's smart card subscription at any
                                        time due to violation of terms of
                                        service, misuse of the smart card
                                        system, or any other reason deemed
                                        necessary by the company. In such cases,
                                        no refunds will be issued to the user.
                                    </p>
                                </div>
                            </div>
                            <div className=" faq-content-wrapper refund-policy-page">
                                <h1 className="text-center mb-5">
                                    Refund Policy
                                </h1>

                                <div className="faq-content-item">
                                    <h2>No Refunds Unless Company Error</h2>
                                    <p>
                                        We regret to inform our users that
                                        refunds are generally not applicable for
                                        purchases made through our Smart Card
                                        Generating system. However, in the event
                                        of a mistake made by the system, we will
                                        promptly address the issue and provide
                                        appropriate compensation. If an error
                                        occurs on our part during the purchase
                                        or generation process, resulting in a
                                        faulty or incorrect smart card, users
                                        are eligible for a refund or replacement
                                        at no additional cost.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h3 className="mb-3 ">
                                        Exclusions from Refund:
                                    </h3>
                                    <h2>User Error:</h2>
                                    <p>
                                        Refunds will not be provided in cases
                                        where errors or inaccuracies arise due
                                        to user input or negligence during the
                                        ordering process. It is the
                                        responsibility of users to ensure the
                                        accuracy of the information provided for
                                        smart card generation.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2>Change of Mind:</h2>
                                    <p>
                                        Refunds will not be granted due to a
                                        change of mind or dissatisfaction with
                                        the digital smart card generated through
                                        our system. We encourage users to
                                        carefully review their order details
                                        before finalizing their purchase.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2>Unused Services:</h2>
                                    <p>
                                        If users choose not to utilize the
                                        digital smart card generated through our
                                        system, refunds will not be issued. The
                                        purchase is considered final upon
                                        completion of the transaction.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h3 className="mb-3 ">
                                        Refund Request Procedure:
                                    </h3>
                                    <h2>Reporting Company Error:</h2>
                                    <p>
                                        In the event of a mistake on our part,
                                        users should promptly contact our
                                        customer support team to report the
                                        issue and request a refund or
                                        replacement.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2>Providing Evidence:</h2>
                                    <p>
                                        Users may be required to provide
                                        evidence or documentation supporting
                                        their claim of a company error, such as
                                        screenshots or descriptions of the issue
                                        encountered.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2>Resolution Process:</h2>
                                    <p>
                                        Upon receiving a refund request, our
                                        team will thoroughly investigate the
                                        reported error and take appropriate
                                        action to rectify the situation. Refunds
                                        or replacements will be processed in a
                                        timely manner.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2>Contact Information:</h2>
                                    <p className="description-content">
                                        For inquiries regarding our refund
                                        policy or assistance with refund
                                        requests, users can contact our customer
                                        support team at
                                        <span>
                                            {' '}
                                            <a
                                                href="mailto:info.womenindigital@gmail.com"
                                                className="email-link-item">
                                                info.womenindigital@gmail.com
                                            </a>
                                        </span>{' '}
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2>Policy Updates:</h2>
                                    <p>
                                        Smart Card Generator reserves the right
                                        to update or modify this refund policy
                                        at any time without prior notice. Users
                                        are encouraged to review the policy
                                        periodically for any changes.
                                    </p>
                                    <br />
                                    <p>
                                        By purchasing and activating a smart
                                        card subscription, users agree to abide
                                        by the terms and conditions outlined in
                                        this cancellation policy. The company
                                        reserves the right to modify this policy
                                        at any time without prior notice.
                                    </p>
                                    <br />
                                    <p>
                                        Thank you for choosing Smart Card
                                        Generator for your digital card needs.
                                        We appreciate your understanding and
                                        support.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default RefoundPolicyPage
